import React, { useContext, useState } from "react";

import CloseIcon from "@atlaskit/icon/glyph/editor/close";
import SearchIcon from "@atlaskit/icon/glyph/editor/search";

import { PROVIDERS } from "../../MacroIcon/Icon";
import {
  ProviderOptionsContainer,
  ProviderSelector,
  CloseButton,
} from "./styled/Components";
import { SidebarIconsContext } from "./Context";

import { TextField } from "../../../Styled/atlaskitComponents";

function SelectProviders() {
  const [searchValue, setSearchValue] = useState(window.searchTerm || "");

  const { selectedProvider, selectProvider, setSearchTerm } =
    useContext(SidebarIconsContext);

  return (
    <>
      <TextField
        placeholder="Search"
        value={searchValue}
        elemAfterInput={
          searchValue ? (
            <CloseButton
              onClick={() => {
                setSearchValue("");
                setSearchTerm("");
              }}
            >
              <CloseIcon />
            </CloseButton>
          ) : (
            <SearchIcon size="large" />
          )
        }
        onChange={(e) => {
          const { value } = e.target;
          window.searchTerm = value;
          setSearchValue(value);

          setTimeout(() => {
            if (window.searchTerm === value) {
              setSearchTerm(value);
            }
          }, 500);
        }}
      />

      <ProviderOptionsContainer>
        {PROVIDERS.map(({ key, name }) => (
          <ProviderSelector
            isChecked={selectedProvider === key}
            key={key}
            onClick={() => selectProvider(key)}
          >
            {name}
          </ProviderSelector>
        ))}
      </ProviderOptionsContainer>
    </>
  );
}

export default SelectProviders;
